import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { SebbieTask } from 'src/app/models/sebbietask.model';
import { StreApperInfo } from 'src/app/models/streapper-info.model';
import { AuthService } from 'src/app/services/auth.service';
import { SebbieService } from 'src/app/services/sebbie.service';

@Component({
    selector: 'completed-tasks-widget',
    templateUrl: './completed-tasks-widget.component.html',
    styleUrl: './completed-tasks-widget.component.scss',
    standalone: false
})
export class CompletedTasksWidgetComponent implements OnInit{
  private readonly destroyRef = inject(DestroyRef);

  @Input() profile: StreApperInfo;
  @Input() isStreapper$: Observable<boolean>;

  isStreapper: boolean = false;
  availableTasks: Array<SebbieTask> = [];

  constructor(
    private readonly authService: AuthService,
    private readonly sebbieService: SebbieService
  ) { }

  ngOnInit(): void {
    this.isStreapper$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(isStreapper => {
        this.isStreapper = isStreapper;

        if(!isStreapper) return;

        this.getCurrentPromotionActionTasks()
            .then(tasks => {
              this.availableTasks = tasks;
            });
      })
  }

  isTaskCompleted(task: SebbieTask): boolean {
    return this.profile.completedSebbieTasks?.some(
      (completedTask) => completedTask.id === task.id
    );
  }

  async getCurrentPromotionActionTasks(): Promise<Array<SebbieTask>> {
    try {
      const tasks = await this.sebbieService.getCurrentPromotionActionTasks(this.authService.authorizationHeaderValue);
      return tasks;
    } catch (error: Error | any) {
      console.error('Error fetching current promotion action tasks:', error);
      return [];
    }
  }
}
